export const cacheKeys = {
  getIpLocation: 'getIpLocation',
  searchAddress: 'searchAddress',
  getLocation: 'getLocation',
};
